var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333333 4.2333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 0.35725833,0.71109177 c -0.47634022,0.47634873 -0.47634866,1.38038053 0,1.85672923 1.74894047,1.748932 1.76992377,1.7488897 3.51881347,-8.4e-6 0.4763487,-0.4763403 0.4763487,-1.3803721 0,-1.85672083 -0.4763486,-0.47634866 -1.2432962,-0.47634866 -1.7196533,0 l -0.039787,0.0397872 -0.039703,-0.0397872 c -0.4763402,-0.47634866 -1.24331306,-0.47634866 -1.71965328,0 z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d1f55d5b5c4dcd419a53abddc7bd164d.svg";
export { ForwardRef as ReactComponent };